import { WishlistItem } from 'src/app/shared/models';

export interface WishlistState {
  items: WishlistItem[];
  loading: boolean;
  error?: string | null;
}

export const initialState: WishlistState = {
  items: [],
  loading: false,
  error: null,
};
